import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import React, { useRef, useState } from 'react'
import { useFieldArray } from 'react-hook-form'
import { confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'

export default function ListaCestNcmItem({ form, service }) {
    const { control } = form

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'lista_cest_ncm_item'
    })

    const [ncmDigitado, setNcmDigitado] = useState('')
    const [cestDigitado, setCestDigitado] = useState('')
    const toast = useRef(null)

    const adicionar = (e) => {
        e.preventDefault()

        if (!ncmDigitado.trim() || !cestDigitado.trim()) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Informe o CEST e o NCM.', life: 4000 })
            return
        }

        const ncmWider = service.getNcmWider(fields, ncmDigitado)
        if (ncmWider) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Atenção',
                detail: `Já existe um NCM mais abrangente cadastrado (${ncmWider}).`,
                life: 5000
            })
            return
        }

        append(service.getNewListaCestNcmItem({
            ncm_lcni: ncmDigitado,
            cest_lcni: cestDigitado
        }))
        setNcmDigitado('')
        setCestDigitado('')
    }

    const getIndexById = (row) =>
        fields.findIndex((item) => item.id === row.id)

    return (
        <>
            <Toast ref={toast} />
            <div className="md:col-12 lg:col-8 xl:col-6 col-12 pt-0 pl-2 pb-3">
                <label className="text-sm">Adicionar CEST/NCM</label>

                <div className="flex gap-2 pt-1">
                    <InputText
                        id='typeCest'
                        className="p-inputtext-sm"
                        placeholder="CEST"
                        value={cestDigitado}
                        onKeyDown={(e) => e.key.length === 1 && !/\d/.test(e.key) && e.preventDefault()}
                        onChange={(e) => setCestDigitado(e.target.value)}
                        inputMode='numeric'
                    />
                    <InputText
                        id='typeCestNcm'
                        className="p-inputtext-sm"
                        placeholder="NCM"
                        value={ncmDigitado}
                        onKeyDown={(e) => e.key.length === 1 && !/\d/.test(e.key) && e.preventDefault()}
                        onChange={(e) => setNcmDigitado(e.target.value)}
                        inputMode='numeric'
                    />
                    <Button
                        id='addCestNcm'
                        icon="pi pi-plus"
                        onClick={adicionar}
                        severity="success"
                        size="small"
                    />
                </div>
            </div>

            <div className="col-12">
                <DataTable
                    value={fields}
                    dataKey="id"
                    className="text-sm"
                    size='small'
                >

                    <Column
                        header="CEST"
                        field='cest_lcni'
                        className="w-6"
                    />
                    <Column
                        header="NCM"
                        field='ncm_lcni'
                        className="w-6"
                    />

                    <Column
                        header=""
                        body={(row) => {
                            const index = getIndexById(row)
                            return (
                                <Button
                                    id='remCestNcm'
                                    icon="pi pi-trash"
                                    text
                                    severity="danger"
                                    size="small"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        const atual = fields[index]
                                        const descricao = `${atual?.cest_lcni || ''} / ${atual?.ncm_lcni || ''}`.trim()

                                        confirmDialog({
                                            message: 'Confirma remover? ' + descricao, icon: 'pi pi-question-circle', accept: () => {

                                                const removeds = form.getValues(`listaCestNcmItemRemoved`) || []
                                                if (atual?.codigo_lcni) {
                                                    removeds.push({ codigo_lcni: atual?.codigo_lcni })
                                                    form.setValue('listaCestNcmItemRemoved', removeds)
                                                }
                                                remove(index)
                                            }
                                        })

                                    }}
                                />
                            )
                        }}
                    />
                </DataTable>
            </div>
        </>
    )
}
